/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCoursesRouteImport } from './routes/_app/courses'
import { Route as AppInvitesRouteImport } from './routes/_app/invites'
import { Route as AppPackagesRouteImport } from './routes/_app/packages'
import { Route as AppScheduleRouteImport } from './routes/_app/schedule'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as SetupTokenRouteImport } from './routes/setup.$token'
import { Route as AppPeopleIndexRouteImport } from './routes/_app/people.index'
import { Route as AppPeopleIdRouteImport } from './routes/_app/people.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCoursesRoute = AppCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AppRoute,
} as any)
const AppInvitesRoute = AppInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppRoute,
} as any)
const AppPackagesRoute = AppPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleRoute = AppScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupTokenRoute = SetupTokenRouteImport.update({
  id: '/setup/$token',
  path: '/setup/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPeopleIndexRoute = AppPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIdRoute = AppPeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/courses': typeof AppCoursesRoute
  '/invites': typeof AppInvitesRoute
  '/packages': typeof AppPackagesRoute
  '/schedule': typeof AppScheduleRoute
  '/settings': typeof AppSettingsRoute
  '/join/$token': typeof JoinTokenRoute
  '/setup/$token': typeof SetupTokenRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/people/': typeof AppPeopleIndexRoute
}
export interface FileRoutesByTo {
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/courses': typeof AppCoursesRoute
  '/invites': typeof AppInvitesRoute
  '/packages': typeof AppPackagesRoute
  '/schedule': typeof AppScheduleRoute
  '/settings': typeof AppSettingsRoute
  '/join/$token': typeof JoinTokenRoute
  '/setup/$token': typeof SetupTokenRoute
  '/': typeof AppIndexRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/people': typeof AppPeopleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/_app/courses': typeof AppCoursesRoute
  '/_app/invites': typeof AppInvitesRoute
  '/_app/packages': typeof AppPackagesRoute
  '/_app/schedule': typeof AppScheduleRoute
  '/_app/settings': typeof AppSettingsRoute
  '/join/$token': typeof JoinTokenRoute
  '/setup/$token': typeof SetupTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/people/$id': typeof AppPeopleIdRoute
  '/_app/people/': typeof AppPeopleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot'
    | '/login'
    | '/courses'
    | '/invites'
    | '/packages'
    | '/schedule'
    | '/settings'
    | '/join/$token'
    | '/setup/$token'
    | '/people/$id'
    | '/people/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot'
    | '/login'
    | '/courses'
    | '/invites'
    | '/packages'
    | '/schedule'
    | '/settings'
    | '/join/$token'
    | '/setup/$token'
    | '/'
    | '/people/$id'
    | '/people'
  id:
    | '__root__'
    | '/_app'
    | '/forgot'
    | '/login'
    | '/_app/courses'
    | '/_app/invites'
    | '/_app/packages'
    | '/_app/schedule'
    | '/_app/settings'
    | '/join/$token'
    | '/setup/$token'
    | '/_app/'
    | '/_app/people/$id'
    | '/_app/people/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  JoinTokenRoute: typeof JoinTokenRoute
  SetupTokenRoute: typeof SetupTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/courses': {
      id: '/_app/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AppCoursesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invites': {
      id: '/_app/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof AppInvitesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packages': {
      id: '/_app/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AppPackagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/$token': {
      id: '/setup/$token'
      path: '/setup/$token'
      fullPath: '/setup/$token'
      preLoaderRoute: typeof SetupTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/people/': {
      id: '/_app/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AppPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/$id': {
      id: '/_app/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof AppPeopleIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCoursesRoute: typeof AppCoursesRoute
  AppInvitesRoute: typeof AppInvitesRoute
  AppPackagesRoute: typeof AppPackagesRoute
  AppScheduleRoute: typeof AppScheduleRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPeopleIdRoute: typeof AppPeopleIdRoute
  AppPeopleIndexRoute: typeof AppPeopleIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCoursesRoute: AppCoursesRoute,
  AppInvitesRoute: AppInvitesRoute,
  AppPackagesRoute: AppPackagesRoute,
  AppScheduleRoute: AppScheduleRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppPeopleIdRoute: AppPeopleIdRoute,
  AppPeopleIndexRoute: AppPeopleIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  JoinTokenRoute: JoinTokenRoute,
  SetupTokenRoute: SetupTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
